import { EquationIdentifier } from '@models/equation-builder';

export const reservedWords: EquationIdentifier[] = [
  {
    name: 'CurrDate',
    desc: 'Date for which the equation is being evaluated',
    syntax: 'CurrDate',
    example: 'CurrDate'
  },
  {
    name: 'CpDate',
    desc: 'Current Position Date',
    syntax: 'CpDate',
    example: 'CpDate'
  },
  {
    name: 'ScenarioMn',
    desc: 'Returns the active scenarios mnemonic',
    syntax: 'ScenarioMn',
    example: 'ScenarioMn'
  },
  {
    name: 'this',
    desc: 'Returns returns the active exogenous line or liquidity source that is being evaluated',
    syntax: 'this',
    example: 'this'
  },
  {
    name: 'PdNum',
    desc: 'Returns the current evaluation period for the equation',
    syntax: 'PdNum',
    example: 'PdNum'
  }
];
